// ════════════════════════════════════════════════════════════════════════
//  Sterne – was für den ganzen Lehrgang gilt
//
//  Die kleinste Seite der Arbeitsfläche, und die mit den Folgen: die Schwellen
//  entscheiden, wie viele Sterne ein Kind sieht.
//
//  Titel und Kennung standen hier einmal. Sie sind aber keine Angaben über eine
//  FASSUNG, sondern über den Lehrgang – und die Kennung ließ sich hier ändern,
//  solange nichts veröffentlicht war. Mit mehreren Lehrgängen ist sie ihre
//  Identität: sie steht in der Adresse, im Dateipfad und in dem, was `curricula`
//  darüber sagt. Beides liegt deshalb in den Stammdaten.
// ════════════════════════════════════════════════════════════════════════

import type { Bundle } from "@otto/lehrgang";
import { Link } from "react-router-dom";
import { useDraft } from "../../../shared/context/DraftContext.js";
import { coursePath, useCourseSlug } from "../../../shared/lib/coursePath.js";
import { NoDraft } from "../../draft/components/NoDraft.js";
import { useAnchorFocus } from "../../../shared/hooks/useAnchorFocus.js";
import { ProblemList } from "../../validation/components/ProblemList.js";
import { problemsAt } from "../../validation/lib/validation.js";
import { anchors } from "../../validation/lib/problemTarget.js";
import styles from "../../../shared/components/shell.module.css";
import own from "./settings.module.css";

export function TitleAndStars() {
  const slug = useCourseSlug();
  const { bundle, setBundle, problems, readOnly } = useDraft();
  useAnchorFocus();
  if (!bundle) return <NoDraft />;

  const change = (part: Partial<Bundle>) => setBundle({ ...bundle, ...part });

  return (
    <div className={styles.card}>
      <h1 className={styles.title}>Sterne</h1>
      <p className={styles.subtitle}>
        Gilt für den ganzen Lehrgang. Titel und Kürzel stehen in den{" "}
        <Link to={coursePath(slug, "stammdaten")}>Stammdaten</Link> – sie gehören zum
        Lehrgang und nicht zu einer Fassung.
      </p>

      <div id={anchors.stars} className={styles.spaced}>
        <h2 className={own.section}>Sterne</h2>
        <ProblemList problems={problemsAt(problems, "starThresholds")} />

        <div className={`${own.pair} ${own.limit}`}>
          <label>
            Drei Sterne ab Genauigkeit
            <input
              className={styles.field}
              type="number"
              min={0}
              max={1}
              step={0.01}
              value={bundle.starThresholds.three}
              readOnly={readOnly}
              onChange={(e) =>
                change({
                  starThresholds: {
                    ...bundle.starThresholds,
                    three: Number(e.target.value),
                  },
                })
              }
            />
          </label>
          <label>
            Zwei Sterne ab Genauigkeit
            <input
              className={styles.field}
              type="number"
              min={0}
              max={1}
              step={0.01}
              value={bundle.starThresholds.two}
              readOnly={readOnly}
              onChange={(e) =>
                change({
                  starThresholds: {
                    ...bundle.starThresholds,
                    two: Number(e.target.value),
                  },
                })
              }
            />
          </label>
        </div>
        <p className={own.note}>
          Dieselben Schwellen stehen in <code>student_save_progress</code> im SQL. Wer sie
          hier ändert, muss sie dort mitändern – sonst zeigen Kind und Lehrkraft
          verschiedene Zahlen.
        </p>
      </div>
    </div>
  );
}
